import CitySEOHead from "@/components/feature/CitySEOHead";
import LakeMaryHeroSection from "./components/HeroSection";
import LakeMaryStickyNav from "./components/StickyNav";
import LakeMaryProcessingTimeSection from "./components/ProcessingTimeSection";
import LakeMaryServicesSection from "./components/ServicesSection";
import LakeMaryLocalAreaSection, { landmarks } from "./components/LocalAreaSection";
import LakeMaryTravelTimingSection from "./components/TravelTimingSection";
import LakeMaryDestinationsSection from "./components/DestinationsSection";
import LakeMaryTestimonialsSection from "./components/TestimonialsSection";
import LakeMaryAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import LakeMaryComparisonSection from "./components/ComparisonSection";
import LakeMaryMistakesSection from "./components/MistakesSection";
import LakeMaryHowItWorksSection from "./components/HowItWorksSection";
import LakeMaryFAQSection, { faqs } from "./components/FAQSection";
import LakeMaryHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import LakeMaryFinalCTA from "./components/FinalCTA";

const areaServedList = [
  { "@type": "City", name: "Lake Mary" },
  { "@type": "City", name: "Sanford" },
  { "@type": "City", name: "Heathrow" },
  { "@type": "City", name: "Longwood" },
  { "@type": "City", name: "Winter Springs" },
  { "@type": "City", name: "Altamonte Springs" },
  { "@type": "City", name: "Oviedo" },
  { "@type": "AdministrativeArea", name: "Seminole County" },
];

const serviceAreaDesc = "Fast Passport Center is a registered U.S. Department of State passport courier serving Lake Mary, Sanford, Longwood, and Seminole County with expedited passport processing as fast as 24 hours. A+ BBB rated.";

const lakeMaryServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function LakeMaryPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Lake Mary"
        state="Florida"
        stateAbbr="FL"
        route="/lake-mary"
        title="Emergency Passport Lake Mary, FL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Lake Mary, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Seminole County corporate professionals, families, and travelers."
        geoPlacename="Lake Mary, Florida"
        geoPosition="28.7589;-81.3178"
        faqs={faqs}
        servicesSchema={lakeMaryServices}
        statePageName="Florida"
        statePageRoute="/states/florida"
        areaServedList={areaServedList}
        serviceAreaDesc={serviceAreaDesc}
        landmarks={landmarks}
      />
      <LakeMaryHeroSection />
      <LakeMaryStickyNav />
      <LakeMaryProcessingTimeSection />
      <LakeMaryLocalAreaSection />
      <LakeMaryServicesSection />
      <LakeMaryTravelTimingSection />
      <LakeMaryDestinationsSection />
      <LakeMaryTestimonialsSection />
      <LakeMaryAcceptanceFacilitiesSection />
      <LakeMaryComparisonSection />
      <LakeMaryMistakesSection />
      <LakeMaryHowItWorksSection />
      <LakeMaryFAQSection />
      <LakeMaryHelpfulResourcesSection />
      <LakeMaryFinalCTA />
    </div>
  );
}